import PhoneNumberDisplayEdit from './PhoneNumberDisplayEdit'

export default PhoneNumberDisplayEdit
